import { call, take, put } from 'redux-saga/effects';
import { get, post, deleteMethod, putMethod } from '../../utils/api';
import settings from '../../utils/settings';
import { getToken } from '../../utils/helper';
import DOMPurify from 'isomorphic-dompurify';
import {
  GET_ENLIGHTEN_NOTICES_REQUEST,
  GET_ENLIGHTEN_NOTICES_SUCCESS,
  GET_ENLIGHTEN_NOTICES_FAILURE,
  ENLIGHTEN_NOTICES_POPULATE_REQUEST,
  ENLIGHTEN_NOTICES_POPULATE_FAILURE,
  ENLIGHTEN_NOTICES_DELETE_REQUEST,
  ENLIGHTEN_NOTICES_DELETE_SUCCESS,
  ENLIGHTEN_NOTICES_DELETE_FAILURE,
  GET_NOTICE_S3_URL_REQUEST,
  GET_USER_EMAILS_FAILURE,
  GET_USER_EMAILS_REQUEST,
  GET_USER_EMAILS_SUCCESS,
  DELETE_IMAGE_S3_URL_REQUEST,
  DELETE_IMAGE_S3_URL_SUCCESS,
  DELETE_IMAGE_S3_URL_FAILURE,
  GET_REVENUE_REPORT_FILE_REQUEST,
  GET_REVENUE_REPORT_FILE_FAILURE,
  GET_REVENUE_REPORT_FILE_SUCCESS,
  UPDATE_SERVICE_ROLES_REQUEST,
  UPDATE_SERVICE_ROLES_FAILURE,
  UPDATE_SERVICE_ROLES_SUCCESS,
  GET_SERVICE_ROLES_REQUEST,
  GET_SERVICE_ROLES_SUCCESS,
  GET_SERVICE_ROLES_FAILURE
} from './constants';

export function* getAllEnlightenNoticesFlow() {
  while (true) {
    const request = yield take(GET_ENLIGHTEN_NOTICES_REQUEST);
    const { recordCount, pageNum } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(
          `admin/api/enlighten_notice?limit=${recordCount}&page=${pageNum + 1}`
        )
      });
      if (response.success) {
        const enlightenNotices = response.result || {};
        yield put({
          type: GET_ENLIGHTEN_NOTICES_SUCCESS,
          enlightenNotices
        });
      }
    } catch (error) {
      yield put({ type: GET_ENLIGHTEN_NOTICES_FAILURE, error: error });
    }
  }
}

export function* populateEnlightenNoticeFlow() {
  while (true) {
    const request = yield take(ENLIGHTEN_NOTICES_POPULATE_REQUEST);
    try {
      const {
        data,
        successCbk = () => {},
        failureCbk = () => {},
        isUpdate = false,
        id = ''
      } = request.payload;
      const {
        notice_type,
        title_text,
        message,
        input_type,
        input_options,
        text_box_heading,
        text_box_prefilled_text,
        cta_text,
        toast_message,
        redirection_link,
        start_date,
        end_date,
        image_lg_url,
        image_md_url,
        image_sm_url,
        image_href,
        dismissable,
        application_keys,
        email_file,
        locale,
        country_code,
        emailIds
      } = data;
      var formData = new FormData();
      if (locale) {
        formData.append('enlighten_notice[locale]', locale);
      }
      if (country_code) {
        formData.append('enlighten_notice[country_code]', country_code);
      }
      if (emailIds) {
        formData.append('enlighten_notice[user_ids]', emailIds);
      }
      if (email_file) {
        formData.append(
          'enlighten_notice[csv_file]',
          email_file,
          email_file.name,
          email_file.type
        );
      }
      if (notice_type === 1) {
        formData.append('enlighten_notice[notice_type]', 1);
        formData.append('enlighten_notice[message]', message);
        if (start_date) {
          formData.append('enlighten_notice[start_date]', start_date);
        }
        if (end_date) {
          formData.append('enlighten_notice[end_date]', end_date);
        }
        formData.append('enlighten_notice[dismissable]', dismissable);
        if (application_keys.includes('itk')) {
          formData.append('enlighten_notice[applications][itk]', 8);
        }
        if (application_keys.includes('mobile')) {
          formData.append('enlighten_notice[applications][mobile]', 4);
        }
        if (application_keys.includes('my_enlighten')) {
          formData.append('enlighten_notice[applications][my_enlighten]', 2);
        }
        if (application_keys.includes('enlighten_manager')) {
          formData.append(
            'enlighten_notice[applications][enlighten_manager]',
            1
          );
        }
      } else if (notice_type === 2) {
        formData.append('enlighten_notice[notice_type]', 2);
        if (image_lg_url) {
          formData.append('enlighten_notice[image_lg_url]', image_lg_url);
        }
        if (image_md_url) {
          formData.append('enlighten_notice[image_md_url]', image_md_url);
        }
        if (image_sm_url) {
          formData.append('enlighten_notice[image_sm_url]', image_sm_url);
        }
        formData.append('enlighten_notice[image_href]', image_href);
        if (start_date) {
          formData.append('enlighten_notice[start_date]', start_date);
        }
        if (end_date) {
          formData.append('enlighten_notice[end_date]', end_date);
        }
        formData.append('enlighten_notice[dismissable]', dismissable);
        if (application_keys.includes('itk')) {
          formData.append('enlighten_notice[applications][itk]', 8);
        }
        if (application_keys.includes('mobile')) {
          formData.append('enlighten_notice[applications][mobile]', 4);
        }
        if (application_keys.includes('my_enlighten')) {
          formData.append('enlighten_notice[applications][my_enlighten]', 2);
        }
        if (application_keys.includes('enlighten_manager')) {
          formData.append(
            'enlighten_notice[applications][enlighten_manager]',
            1
          );
        }
      } else if (notice_type === 4) {
        formData.append('enlighten_notice[notice_type]', 4);
        formData.append(
          'enlighten_notice[title_text]',
          DOMPurify.sanitize(title_text, {
            USE_PROFILES: { html: true }
          })
        );
        formData.append(
          'enlighten_notice[message]',
          DOMPurify.sanitize(message, {
            USE_PROFILES: { html: true }
          })
        );
        if (image_lg_url) {
          formData.append('enlighten_notice[image_lg_url]', image_lg_url);
        }
        if (image_md_url) {
          formData.append('enlighten_notice[image_md_url]', image_md_url);
        }
        if (image_sm_url) {
          formData.append('enlighten_notice[image_sm_url]', image_sm_url);
        }
        formData.append(
          'enlighten_notice[image_href]',
          DOMPurify.sanitize(image_href, {
            USE_PROFILES: { html: false }
          })
        );
        formData.append('enlighten_notice[input_type]', input_type);
        if (input_type !== 'ratings') {
          formData.append(
            'enlighten_notice[input_options]',
            DOMPurify.sanitize(JSON.stringify(input_options), {
              USE_PROFILES: { html: true }
            })
          );
        } else {
          formData.append(
            'enlighten_notice[toast_message]',
            DOMPurify.sanitize(toast_message, {
              USE_PROFILES: { html: true }
            })
          );
        }
        if (input_type === 'multiple-select') {
          if (toast_message) {
            formData.append(
              'enlighten_notice[toast_message]',
              DOMPurify.sanitize(toast_message, {
                USE_PROFILES: { html: true }
              })
            );
          } else {
            formData.append(
              'enlighten_notice[redirection_link]',
              DOMPurify.sanitize(redirection_link, {
                USE_PROFILES: { html: false }
              })
            );
          }
        }

        formData.append(
          'enlighten_notice[text_box_heading]',
          DOMPurify.sanitize(text_box_heading, {
            USE_PROFILES: { html: true }
          })
        );
        formData.append(
          'enlighten_notice[text_box_prefilled_text]',
          DOMPurify.sanitize(text_box_prefilled_text, {
            USE_PROFILES: { html: true }
          })
        );
        formData.append(
          'enlighten_notice[cta_text]',
          DOMPurify.sanitize(cta_text, {
            USE_PROFILES: { html: true }
          })
        );
        formData.append(
          'enlighten_notice[is_text_box_present]',
          !!(text_box_prefilled_text || text_box_heading)
        );
        if (start_date) {
          formData.append('enlighten_notice[start_date]', start_date);
        }
        if (end_date) {
          formData.append('enlighten_notice[end_date]', end_date);
        }
        formData.append('enlighten_notice[dismissable]', dismissable);
        if (application_keys.includes('itk')) {
          formData.append('enlighten_notice[applications][itk]', 8);
        }
        if (application_keys.includes('mobile')) {
          formData.append('enlighten_notice[applications][mobile]', 4);
        }
        if (application_keys.includes('my_enlighten')) {
          formData.append('enlighten_notice[applications][my_enlighten]', 2);
        }
        if (application_keys.includes('enlighten_manager')) {
          formData.append(
            'enlighten_notice[applications][enlighten_manager]',
            1
          );
        }
      } else {
        formData.append('enlighten_notice[notice_type]', 3);
        formData.append('enlighten_notice[message]', message);
        if (start_date) {
          formData.append('enlighten_notice[start_date]', start_date);
        }
      }
      var requestOptions = {
        method: isUpdate ? 'PUT' : 'POST',
        body: formData,
        headers: {
          Authorization: `${getToken()}`
        }
      };
      const urlPath = isUpdate
        ? `admin/api/enlighten_notice/${id}`
        : `admin/api/enlighten_notice`;
      fetch(settings.getApiUrl(urlPath), requestOptions)
        .then((data) => {
          const { status } = data;
          data.json().then((response) => {
            if (status === 200) {
              successCbk(response.result);
            } else {
              failureCbk(response.message);
            }
          });
        })
        .catch((error) => {
          failureCbk(error);
        });
    } catch (error) {
      yield put({ type: ENLIGHTEN_NOTICES_POPULATE_FAILURE, error: error });
    }
  }
}

export function* deleteEnlightenNoticeFlow() {
  while (true) {
    try {
      const request = yield take(ENLIGHTEN_NOTICES_DELETE_REQUEST);
      let response;
      const { id, successCbk = () => {} } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.getApiUrl(`admin/api/enlighten_notice/${id}`),
        headers: { Authorization: `${getToken()}` }
      });
      if (response.success) {
        yield put({ type: ENLIGHTEN_NOTICES_DELETE_SUCCESS });
        successCbk();
      } else {
        yield put({
          type: ENLIGHTEN_NOTICES_DELETE_FAILURE,
          error: response.result.message || response.result.messages
        });
        console.log(
          'Saga: deleteEnlightenNoticeFlow:',
          response.result.message || response.result.messages
        );
      }
    } catch (error) {
      console.log('Saga: deleteEnlightenNoticeFlow:', error);
      yield put({ type: ENLIGHTEN_NOTICES_DELETE_FAILURE, error: error });
    }
  }
}

export function* getNoticeS3UrlFlow() {
  while (true) {
    const request = yield take(GET_NOTICE_S3_URL_REQUEST);
    try {
      const {
        fileObj,
        successCbk = () => {},
        failureCbk = () => {}
      } = request.payload;
      var formData = new FormData();
      formData.append('file', fileObj);
      var requestOptions = {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${getToken()}` }
      };
      fetch(settings.einCoreUrl(`banner`), requestOptions)
        .then((data) => {
          const { status } = data;
          data.json().then((response) => {
            if (status === 200) {
              successCbk(response);
            } else {
              failureCbk();
            }
          });
        })
        .catch((error) => {
          console.log('error in getNoticeS3UrlFlow', error);
          failureCbk();
        });
    } catch (error) {
      console.log('Saga: getNoticeS3UrlFlow:', error);
    }
  }
}

export function* emailIdFlow() {
  while (true) {
    const request = yield take(GET_USER_EMAILS_REQUEST);
    try {
      const { userObj } = request.payload;
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`admin/api/user_search`),
        body: userObj
      });

      if (response.success) {
        const { status, result } = response;
        if (status === 200) {
          const emailIdList = result.users || [];
          yield put({ type: GET_USER_EMAILS_SUCCESS, emailIdList });
        } else {
          yield put({
            type: GET_USER_EMAILS_FAILURE,
            error: response.result.message || response.result.messages
          });
          console.log(
            'Saga: emailIdFlow:',
            response.result.message || response.result.messages
          );
        }
      }
    } catch (error) {
      console.log('Saga: emailIdFlow:', error);
      yield put({ type: GET_USER_EMAILS_FAILURE, error: error });
    }
  }
}

export function* deleteImageS3UrlFlow() {
  while (true) {
    const request = yield take(DELETE_IMAGE_S3_URL_REQUEST);
    try {
      let response;
      const {
        deleteObject,
        successCbk = () => {},
        failureCbk = () => {}
      } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.einCoreUrl(`banner`),
        body: deleteObject,
        withBearer: true
      });
      if (response.succes) {
        yield put({ type: DELETE_IMAGE_S3_URL_SUCCESS });
        successCbk();
      } else {
        yield put({
          type: DELETE_IMAGE_S3_URL_FAILURE,
          error: response.result.message || response.result.messages
        });
        console.log(
          'Saga: deleteImageS3UrlFlow',
          response.result.message || response.result.messages
        );
        failureCbk();
      }
    } catch (error) {
      console.log('Saga: deleteImageS3UrlFlow', error);
      yield put({
        type: DELETE_IMAGE_S3_URL_FAILURE,
        error: error
      });
    }
  }
}

export function* getRevenueReportFileFlow() {
  while (true) {
    const request = yield take(GET_REVENUE_REPORT_FILE_REQUEST);
    try {
      let response;
      const {
        aspect,
        service,
        startDate,
        endDate,
        successCbk = () => {}
      } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(
          `analytics/${aspect}/${service}?start=${startDate}&end=${endDate}`
        ),
        withBearer: true
      });
      if (response.success) {
        successCbk();
        yield put({
          type: GET_REVENUE_REPORT_FILE_SUCCESS,
          revenueReportFile: response.result.data
        });
      } else {
        yield put({
          type: GET_REVENUE_REPORT_FILE_FAILURE,
          error: response.result.message || response.result.messages
        });
        console.log(
          'Saga: getRevenueReportFileFlow',
          response.result.message || response.result.messages
        );
      }
    } catch (error) {
      console.log('Saga: getRevenueReportFileFlow', error);
      yield put({ type: GET_REVENUE_REPORT_FILE_FAILURE, error: error });
    }
  }
}

export function* getServiceRolesFlow() {
  while (true) {
    const request = yield take(GET_SERVICE_ROLES_REQUEST);
    const { userId, successCbk = () => {} } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`api_internal/admin/service_roles/${userId}`)
      });
      if (response.success) {
        const { service_roles, available_service_roles } = response.result;
        yield put({
          type: GET_SERVICE_ROLES_SUCCESS,
          availableServiceRoles: available_service_roles
        });
        successCbk(service_roles);
      } else {
        yield put({
          type: GET_SERVICE_ROLES_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({
        type: GET_SERVICE_ROLES_FAILURE,
        error: error
      });
    }
  }
}

export function* updateServiceRolesFlow() {
  while (true) {
    const request = yield take(UPDATE_SERVICE_ROLES_REQUEST);
    try {
      let response;
      const { serviceAccessObject, userId } = request.payload;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`api_internal/admin/service_roles/${userId}`),
        body: serviceAccessObject
      });
      if (response.success) {
        yield put({
          type: UPDATE_SERVICE_ROLES_SUCCESS
        });
      } else {
        yield put({
          type: UPDATE_SERVICE_ROLES_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({
        type: UPDATE_SERVICE_ROLES_FAILURE,
        error: error
      });
    }
  }
}
